import { render } from "./Recommendation.vue?vue&type=template&id=29b440a0&scoped=true"
import script from "./Recommendation.vue?vue&type=script&lang=js"
export * from "./Recommendation.vue?vue&type=script&lang=js"

import "./Recommendation.vue?vue&type=style&index=0&id=29b440a0&scoped=true&lang=less"

import exportComponent from "C:\\Users\\sander\\IdeaProjects\\matchmaking\\fbm-matchmaking\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b440a0"]])

export default __exports__